import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Breadcrumb, Col, Layout, Spin,
} from 'antd';
import { Link } from 'react-router-dom';
import { firstLetterUpperCase } from '../../../shared/helpers';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import BikeDetail from './components/BikeDetail';
import { NotFound } from '../../App/components/NotFound';

const BreadcrumbItem = Breadcrumb.Item; const
    layout_position = { padding: '0 4%' };

class Index extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const model_update_access = views_permissions['view://PlatformManagement/Bike_model_update'];
        const variant_create_access = views_permissions['view://PlatformManagement/Bike_variant_create'];
        if (!model_update_access) {
            return <NotFound />;
        }
        return (
            <Layout style={layout_position}>
                <Spin spinning={this.props.loading} tip="Loading ..." style={{ minHeight: '45vh' }}>
                    {this.props.model
                        ? (
                            <Col span={24}>
                                <Breadcrumb className="breadcrumbs">
                                    <BreadcrumbItem><Link to="/PlatformManagement/BikeManagement">Bike Management</Link></BreadcrumbItem>
                                    <BreadcrumbItem>
                                        {this.props.model.ref_bike_brand.name}
                                        {' '}
                                        {this.props.model.name}
                                    </BreadcrumbItem>
                                </Breadcrumb>
                                <h3 className="page-title">
                                    {this.props.model.ref_bike_brand.name}
                                    {' '}
                                    {this.props.model.name}
                                </h3>
                                <h3 className="page-subhead subhead">
                                    {
                                        `${firstLetterUpperCase(this.props.model.bike_type)} - ${this.props.model.cc}cc`}
                                </h3>
                            </Col>
                        ) : null}
                </Spin>
                <BikeDetail variant_create_access={!variant_create_access} />
            </Layout>
        );
    }
}


const mapStateToProps = state => ({
    model: state.PlatformManagement.Bike_management.model,
    loading: state.PlatformManagement.Bike_management.loading,
    views_permissions: state.App.Permissions.views_permissions,
});

export default connect(mapStateToProps, null)(checkPermissionsHOC(Index, ['view://PlatformManagement/Bike_model_update', 'view://PlatformManagement/Bike_variant_create']));



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/index.js